<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { CtaBlock } from '../../types'

defineProps<{ block: CtaBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-text) site:py-14 site:text-(--site-color-primary-text) site:@min-[40rem]:py-20">
    <div class="site-site-container site:grid site:items-center site:gap-8 site:@min-[64rem]:grid-cols-[1fr_auto] site:@min-[64rem]:gap-16">
      <div>
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-accent)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:max-w-3xl site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-model="block.content.description" as="p" class="site:mt-5 site:max-w-2xl site:text-lg site:leading-8 site:opacity-75" />
      </div>
      <div class="site:flex site:flex-wrap site:gap-3 site:@min-[64rem]:flex-col">
        <SiteLink :link="block.content.primaryAction" class="site-site-button site:min-w-44">
          {{ block.content.primaryAction.label }}
        </SiteLink>
        <SiteLink v-if="block.content.secondaryAction" :link="block.content.secondaryAction" class="site:inline-flex site:min-w-44 site:items-center site:justify-center site:rounded-(--site-radius-sm) site:border site:border-white/35 site:px-5 site:py-3 site:text-sm site:font-bold">
          {{ block.content.secondaryAction.label }}
        </SiteLink>
      </div>
    </div>
  </section>
</template>
